var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crt__body",class:{ border: !_vm.showButtons}},[_c('span',[_vm._v("Tubber, "),_c('span',[_vm._v(_vm._s(_vm.$t('all-rights-reserved')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }